import React, { FC } from 'react'
import './RegisterForm.scss'
import RegisterWrapperCard from '../RegisterWrapperCard/RegisterWrapperCard'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { MenuItem } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { IRegisterDataForm } from 'app_types/register/registerTypes'
import FormTextField from 'app_components/commons/FormTextField/FormTextField'
import FormSelect from 'app_components/commons/FormSelect/FormSelect'

interface RegisterFormProps {
  defaultValues?: IRegisterDataForm
  onSubmit: (formData: IRegisterDataForm) => void
}

const EMAIL_REGEX_VALIDATION = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

const RegisterForm: FC<RegisterFormProps> = ({ defaultValues, onSubmit }) => {
  const { control, handleSubmit, errors, watch } = useForm<IRegisterDataForm>({ defaultValues })

  return (
    <RegisterWrapperCard title="Registro">
      <form onSubmit={handleSubmit(onSubmit)} className="register-form--layout">
        <div className='register-form--names'>
          <FormTextField
            control={control}
            id='firstName'
            error={errors.firstName}
            label="Nombres"
            required
          />
          <FormTextField
            control={control}
            id='lastName'
            error={errors.lastName}
            label="Apellidos"
            required
          />
        </div>
        <div className="register-form--document-id">
          <FormSelect
            control={control}
            id='documentType'
            label='Tipo'
            variant='outlined'
            error={!!errors?.documentType}
            required
          >
            <MenuItem value="CC">CC</MenuItem>
            <MenuItem value="Otro">Otro</MenuItem>
          </FormSelect>
          <FormTextField
            control={control}
            id='documentNumber'
            error={errors.documentNumber}
            label="Numero de documento"
            required
          />
          <FormTextField
            control={control}
            id='confirmDocumentNumber'
            error={errors.confirmDocumentNumber}
            label="Confirma tu documento"
            required
            validate={(value) => {
              if (watch('documentNumber') !== value) {
                return "El documento de identidad no coincide"
              }
            }}
          />
        </div>
        <FormTextField
          control={control}
          id='email'
          error={errors.email}
          errorText={errors.email?.type === 'pattern' ? "El correo no es valido" : undefined}
          label="Email"
          pattern={EMAIL_REGEX_VALIDATION}
          required
        />
        <FormTextField
          control={control}
          id='confirmEmail'
          error={errors.confirmEmail}
          errorText={errors.confirmEmail?.type === 'pattern' ? "El correo no es valido" : undefined}
          label="Confirma tu correo"
          pattern={EMAIL_REGEX_VALIDATION}
          validate={(value) => {
            if (watch('email') !== value) {
              return "Los correos no coinciden"
            }
          }}
          required
        />
        <ButtonComponent
          textTransform='initial'
          marginTop='auto'
          variant='secondary'
          width="100%"
          paddingTop={12}
          paddingBottom={12}
          fontSize={18}
          type="submit"
        >
          Continuar
        </ButtonComponent>
      </form>
    </RegisterWrapperCard>
  )
}

export default RegisterForm
